import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { StudentLearnerDocumentPage } from '@pages/student';
import type { RouterContext } from '@shared/config/router-context';
import { canAccessPersonalFlow } from '@shared/lib';

export const learnerDocumentSearchSchema = z.object({
  profileRef: z.string().min(1),
  contextKind: z.literal('registration'),
  contextId: z.string().min(1),
});

export const Route = createFileRoute('/$locale/_authenticated/student/documents/$documentId')({
  component: StudentLearnerDocumentRoute,
  validateSearch: learnerDocumentSearchSchema,
  beforeLoad: ({ context, params }) => {
    const routerContext = context as RouterContext;
    if (
      !routerContext.auth.isLoading &&
      !canAccessPersonalFlow(routerContext.ability, routerContext.auth.user?.id ?? null)
    ) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/$locale/unauthorized', params: { locale: params.locale } });
    }
  },
});

function StudentLearnerDocumentRoute() {
  const { locale, documentId } = Route.useParams();
  const { profileRef, contextId } = Route.useSearch();
  return (
    <StudentLearnerDocumentPage
      locale={locale}
      profileRef={profileRef}
      documentId={documentId}
      context={{ kind: 'registration', id: contextId }}
    />
  );
}
